angular.module('env.i18n.uiLocalization', [])

    .run(function (gettextCatalog) {
        if (om.config.build.highlightUntranslatedStrings === true) {
            gettextCatalog.debug = true;
        }
    })

    .service('uiLocalization', function ($q, $http, $log, toastr, gettextCatalog, EventingMixin, LocaleName) {
        var _this = this;
        _this = _.extend(_this, new EventingMixin(['changed']));

        /**
         * Cache of available languages
         * @type {Array}
         */
        var languagesList;

        /**
         * Default language
         * @type {string}
         */
        var defaultLanguage = "en-GB";

        /**
         * Current language
         * @type {string}
         */
        var currentLanguage;

        /**
         * Get list of supported gettext languages
         * @returns {!Promise} promise
         */
        _this.getLanguagesList = function () {
            var deferred = $q.defer();
            if (languagesList) {
                deferred.resolve(languagesList);
            } else {
                $http.get('translations/availableGettextLocales.json')
                    .then(function (resp) {
                        try {
                            languagesList = resp.data;
                            deferred.resolve(languagesList);
                        } catch (err) {
                            languagesList = null;
                            deferred.reject(err);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            }

            return deferred.promise;
        };

        /**
         * Set current language for ui translations
         * @param {string} lang - code of the language
         * @returns {!Promise} promise
         */
        _this.setCurrentLanguage = function (lang) {
            var deferred = $q.defer();

            _this.getLanguagesList().then(
                function (langList) {
                    // get the most suitable language code
                    var languageCode = (new LocaleName(lang)).getMostSuitableLanguage(langList) || defaultLanguage;

                    if (gettextCatalog.strings[languageCode]) {

                        gettextCatalog.setCurrentLanguage(languageCode);
                        currentLanguage = languageCode;
                        _this.events.raise('changed', {language: languageCode});
                        deferred.resolve(languageCode);

                    } else {

                        gettextCatalog.loadRemote("translations/langs/" + languageCode + ".json")
                            .then(function () {
                                gettextCatalog.setCurrentLanguage(languageCode);
                                currentLanguage = languageCode;
                                _this.events.raise('changed', {language: languageCode});
                                deferred.resolve(languageCode);
                            }, function (err) {
                                deferred.reject(err);
                            });

                    }
                },
                function (err) {
                    deferred.reject(err);
                }
            );

            return deferred.promise;
        };

        /**
         * Get current ui localization language
         * @returns {string|undefined} current ui localization language code
         */
        _this.getCurrentLanguage = function () {
            return currentLanguage;
        };

        /**
         * Get UI translation for key. WARNING: Don't forget to use 'gettext' to mark string for translation system
         * @param {string} key
         * @param {string[]} [formatArguments] optional format arguments for `sprintf` function
         * @returns {string} translation
         */
        _this.translate = function (key) {
            var message;

            if (!key) {
                return null;
            }
            var translated = gettextCatalog.getString(key);

            if (arguments.length > 1) { // if we have arguments for string format
                var insertions = _.flatten(Array.prototype.slice.call(arguments, 1));

                if (!translated) {
                    message = "Translation for key `" + key
                        + "` is empty for `" + currentLanguage
                        + "` locale. UI localization engine was unable to format empty string with given arguments: "
                        + insertions.join(', ');
                    $log.warn(message);
                    toastr.warning(message, "UI localization error");
                    return key;
                }

                try {
                    var params = _.union([translated], insertions);
                    return _.string.sprintf.apply(_.string.sprintf, params);
                } catch (error) {
                }
                message = "UI localization engine was unable to format translated string `" + translated
                    + "` (key: '" + key + "', locale: '" + currentLanguage + "') with given arguments: " + insertions.join(', ');
                $log.warn(message);
                toastr.warning(message, "UI localization error");
                return translated;
            }

            return translated;
        };

        return _this;
    })

;